/**
 * GA4 event tracking helper.
 * Sends custom events to Google Analytics when gtag is available.
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>
) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}
